import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import { useHistory, useParams } from 'react-router-dom';
import { StatusCodes } from 'http-status-codes';

import StorageConditionsApi from '~/src/services/api/StorageConditionsApi';
import WhitePad from '~/src/components/common/WhitePad/WhitePad';
import TitleComponent from '~/src/components/common/forms/Title/TitleComponent';
import FormRow from '~/src/components/common/forms/Row/FormRow';
import TextInputComponent from '~/src/components/common/forms/TextInput/TextInputComponent';
import PrimaryButton from '~/src/components/common/forms/Button/PrimaryButton';
import validationSchema from './validationSchema';
import FormWrapper from '~/src/components/common/forms/FormWrapper/FormWrapper';

export default function StorageConditionsEdit(): JSX.Element {
  const { id } = useParams();
  const [itemData, setItemData] = useState({
    conditionDescription: '',
    dataArrived: false,
  });
  const history = useHistory();

  const saveItem = async (values, setSubmitting) => {
    setSubmitting(true);
    let res = null;
    if (id) {
      res = await StorageConditionsApi.update(id, values);
    } else {
      res = await StorageConditionsApi.create(values);
    }
    if (res.status === StatusCodes.OK) {
      history.push('/storage-conditions');
    } else {
      setSubmitting(false);
    }
  };

  const getItem = async () => {
    const res = await StorageConditionsApi.get(id);
    const newItemData = { ...res.data, dataArrived: true };
    setItemData(newItemData);
  };

  useEffect(() => {
    if (id) {
      getItem(id);
    }
  }, []);

  return (
    <>
      <WhitePad>
        <TitleComponent
          onLeftHandler={() => {
            history.goBack();
          }}
          title={`${id ? 'Edit ' : 'Create '}Storage Condition`}
        />
        {id && itemData.dataArrived === false ? null : (
          <Formik
            initialValues={{
              conditionDescription: itemData.conditionDescription,
            }}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
              return saveItem(values, setSubmitting);
            }}
          >
            {({ values, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
              <FormWrapper>
                <form onSubmit={handleSubmit} autoComplete="off">
                  <FormRow>
                    <TextInputComponent
                      name="conditionDescription"
                      label="conditionDescription"
                      value={values.conditionDescription}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      cols={12}
                    />
                  </FormRow>

                  <PrimaryButton variant="primary" isSubmitting={isSubmitting} type="submit" title="Save" />
                </form>
              </FormWrapper>
            )}
          </Formik>
        )}
      </WhitePad>
    </>
  );
}
